<template>
	<div class="tw-flex tw--mx-3">
		<div class="px-3 tw-w-3/5">
			<model-stepper
				:current-step="3"
				class="tw-mb-4"
				@code-step="loadCodeStep">
			</model-stepper>
			<p-card class="tw-mb-4">
				<div class="tw-px-5">
					<span :style="`color:${$appColors.info}`">
						<b style>Puesto Seleccionado: </b> {{ selectedJobs.name }}
					</span>
				</div>
			</p-card>
			<p-card class="factor-list">
				<div class="tw-text-bold factor-list-header tw-py-1 tw-flex tw-justify-center">
					<span>Ingresa los factores y subfactores del proceso</span>
				</div>
				<div class="factor-list-form tw-my-1 tw-flex tw-justify-between tw-items-center tw-gap-x-2">
					<span class="tw-text-center">Nuevo Factor:</span>
					<input
						class="factor-list-input tw-w-full"
						placeholder="Nombre del Factor"
						v-model="factor.name"
					/>
					<input
						class="factor-list-input tw-w-24"
						placeholder="Puntaje"
						type="number"
						v-model="factor.score"
					/>
					<p-button
						type="secondary"
						:disabled="validButton"
						@click="addFactor">Crear Factor
					</p-button>
				</div>
				<p
					class="factor-list-points tw-text-right tw-my-4"
					:style="remainingPoints < 0 || remainingPoints > 0 ? `color:${$appColors.error}` : `color:${$appColors.primary}`">Puntos Restantes: <span>{{ totalSCoreFactors }}</span></p>
				<section class="factors-list" v-if="factors.length !== 0">
					<factor-items
						class="tw-my-4"
						:factor-i="factorI"
						v-for="(factorI, index) in factors"
						:key="index"
						@closeClicked="handlerRemoveFactorItem(factorI)"
						@editClicked="handlerEditFactorItem(factorI)"
						@updateFactorItem="handleUpdateFactorItem($event)">
					</factor-items>
				</section>
				<p-horizontal-divider/>
				<div class="tw-flex tw-justify-center tw-gap-x-4">
					<p-button
						type="secondary"
						@click="returnConfigProcess">Atrás</p-button>
					<p-button
						type="primary"
						:disabled="validatedCreatedButton || validationsSubfactors || validateRemainingPoints"
						@click="saveCongifActivities">Crear Proceso</p-button>
				</div>
			</p-card>
		</div>
		<div class="px-3 tw-w-2/5 fixed-section">
			<model-description
				:title="'PROCESO DE SELECCIÓN'"
				:subtitle="'DESCRIPCIÓN'">
				<div class="tw-my-4 tw-flex tw-flex-col tw-text-center tw-justify-center tw-items-center" slot="content">
					<p class="tw-mb-12 tw-text-left">
						1. Selecciona los puestos que ingresarán al proceso de selección.<br>
						2. Configura el proceso.<br>
						3. Configura las actividades del proceso de selección.<br>
						4. Configura la plantilla para la entrevista.
					</p>
					<p-button
						type="primary"
					>Mire nuestro tutorial paso a paso</p-button>
				</div>
			</model-description>
		</div>
		<edit-factor-dialog
			ref="editDialog"
			:selected-factor="focusedFactor"
			@handlerUpdateItem="handleUpdateFactorItem($event)">
		</edit-factor-dialog>
	</div>
</template>

<script>
import modelStepper from '@/modules/recruitment/components/content/model-stepper';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import SquareBox from '@/modules/shared/components/content/SquareBox';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import factorItems from '@/modules/recruitment/components/content/factor-items';
import EditFactorDialog from '@/modules/recruitment/components/content/edit-factor-dialog';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { clone, pathOr, reject, propEq } from 'ramda';
import { updateFactorList } from '@/modules/recruitment/utils/listElements';

const { getLocalData } = helper;

export default {
	name: 'step-config-activities-recruitment',
	components: {
		modelStepper,
		PCard,
		SquareBox,
		modelDescription,
		PButton,
		PHorizontalDivider,
		factorItems,
		EditFactorDialog,
	},
	data() {
		return {
			codeStep: {},
			remainingPoints: null,
			factor: {
				name: '',
				score: null,
				subFactors: [],
			},
			factors: [
				{
					name: 'ENTREVISTA',
					score: 20,
					flagInterview: true,
					subFactors: [
					],
				},
				{
					name: 'EXPERIENCIA',
					score: 20,
					flagInput: true,
					subFactors: [
						{
							description: 'Experiencia tipo A: EXACTA',
							code: 'EXA',
							score: null,
						},
						{
							description: 'Experiencia tipo B: SIMILAR',
							code: 'EXB',
							score: null,
						},
						{
							description: 'Experiencia tipo C: RELACIONADA',
							code: 'EXC',
							score: null,
						},
					],
				},
				{
					name: 'CAPACITACIÓN',
					score: 20,
					flagInput: true,
					subFactors: [
						{
							description: 'Capacitación tipo A: EXACTA',
							code: 'CA',
							score: null,
						},
						{
							description: 'Capacitación tipo B: SIMILAR',
							code: 'CB',
							score: null,
						},
						{
							description: 'Capacitación tipo C: RELACIONADA',
							code: 'CC',
							score: null,
						},
					],
				},
			],
			focusedFactor: {},
		};
	},
	beforeCreate() {
	},
	created() {
	},
	mounted() {},
	methods: {
		async loadData() {
			try {
				if (this.codeStep) {
					const { data: response } = await this.$httpPraktiko.get(`/recruitment/detail/${this.codeStep.code}/${this.idConfigProcess}`);
					if (Object.keys(response).length > 0) {
						this.factors = response.details;
					}
				}
			} catch (error) {
				this.showGenericError();
			}
		},
		loadCodeStep(obj) {
			this.codeStep = obj;
		},
		returnConfigProcess() {
			this.goTo(this.codeStep.returnTo);
		},
		addFactor() {
			const newFactor = clone(this.factor);
			newFactor.name = newFactor.name.toUpperCase();
			newFactor.score = Number(newFactor.score);
			this.factors.push(newFactor);
			this.clearInputs();
		},
		clearInputs() {
			this.factor.name = null;
			this.factor.score = null;
		},
		handlerRemoveFactorItem(factorItem) {
			this.factors = reject(propEq('name', factorItem.name), this.factors);
		},
		handlerEditFactorItem(factorItem) {
			this.focusedFactor = factorItem;
			this.$refs.editDialog.open();
		},
		handleUpdateFactorItem(factorItem) {
			this.factors = updateFactorList(
				factorItem,
				this.factors,
			);
		},
		async saveCongifActivities() {
			const body = {
				id: this.idConfigProcess,
				typeRecruitmentCode: this.codeStep.code,
				jobId: this.selectedJobs.id,
				details: this.factors,
			};
			try {
				await this.$httpPraktiko.post('/recruitment', body);
				this.showNotification('Actividades Guardadas Exitosamente');
				this.goTo(this.codeStep.goTo);
			} catch (error) {
				this.showGenericError();
			}
		},
	},
	computed: {
		...mapState('recruitment', {
			selectedJobs(state) {
				return pathOr(getLocalData('jobSelected'), ['recruitmentFlow', 'selectedJobs'], state.recruitment) || [];
			},
			idConfigProcess(state) {
				return pathOr(getLocalData('idConfigProcess'), ['idConfigProcess'], state.recruitment) || [];
			},
			dataConfigProcess(state) {
				return pathOr(getLocalData('dataConfigProcess'), ['dataConfigProcess'], state.recruitment) || [];
			},
		}),
		validButton() {
			return !this.factor.name || !this.factor.score;
		},
		validatedCreatedButton() {
			if (!this.factors || this.factors.length === 0) {
				return true;
			}
			return false;
		},
		validationsSubfactors() {
			const hasEmptySubFactors = this.factors.some(factor =>
				!factor.subFactors || factor.subFactors.length === 0);
			return hasEmptySubFactors;
		},
		totalSCoreFactors() {
			const scores = this.factors.map(item => item.score || 0);
			const totalScoreFactor = scores.reduce((acum, curr) => acum + curr, 0);
			this.remainingPoints = 100 - totalScoreFactor;
			return this.remainingPoints;
		},
		validateRemainingPoints() {
			if (this.remainingPoints > 0 || this.remainingPoints < 0) {
				return true;
			}
			return false;
		},
	},
	watch: {
		codeStep: {
			handler(newVal) {
				this.codeStep = newVal;
				this.loadData();
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.factor-list {
	&-header {
		background-color: var(--app-color-primary);
		border-radius: 5px;
		span {
			color: white !important;
			font-weight: bold;
		}
	}
	&-form {
		span {
			color: color(orange-dark);
			width: 250px;
		}
	}

	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, green-dark);
		border-radius: 4px;
        display: block;
        outline: none;
		color: map-get($colors, gray-sidebar);
		margin-top: 4px;
		padding: 5px 20px;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
	&-points {
		font-size: size(large);
		padding-right: 10px;
		font-weight: bold;
		span {
			font-weight: normal;
		}
	}
}
.factors-list {
	overflow: auto;
	height: 50vh;
}
.fixed-section {
	width: 30% !important;
	position: fixed;
	right: 95px;
}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/steps-recruitment/step-config-activities-recruitment.vue